import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import './styles.scss';
import { EventManager, EVENTS } from '@components/Events/events';

export default class ResizablePanels extends Component {

	constructor (props) {
		super(props);
		
		//let panels = Array(props.panels).fill(window.innerWidth/props.panels);
		this.state = {
			isDragging: false,
			panels: Array(props.panels).fill(0),
			oldWindowWidth: 0
		};

		// A new reference is created with every bind
		this.resizePanel = this.resizePanel.bind(this);
		this.stopResize = this.stopResize.bind(this);
		this.updatePanelsSize = this.updatePanelsSize.bind(this);

		this.state.panels = this.updatePanelsSize(true);
		this.state.oldWindowWidth = window.innerWidth;
	}

	componentDidMount () {
		ReactDOM.findDOMNode(this).addEventListener('mousemove', this.resizePanel);
		ReactDOM.findDOMNode(this).addEventListener('mouseup', this.stopResize);
		ReactDOM.findDOMNode(this).addEventListener('mouseleave', this.stopResize);
		ReactDOM.findDOMNode(this).addEventListener('touchmove', this.resizePanel, {passive: false});
		ReactDOM.findDOMNode(this).addEventListener('touchend', this.stopResize);
		ReactDOM.findDOMNode(this).addEventListener('touchcancel', this.stopResize);
		window.addEventListener('resize', this.updatePanelsSize);
	}

	componentWillUnmount(){
		ReactDOM.findDOMNode(this).removeEventListener('mousemove', this.resizePanel);
		ReactDOM.findDOMNode(this).removeEventListener('mouseup', this.stopResize);
		ReactDOM.findDOMNode(this).removeEventListener('mouseleave', this.stopResize);
		ReactDOM.findDOMNode(this).removeEventListener('touchmove', this.resizePanel);
		ReactDOM.findDOMNode(this).removeEventListener('touchend', this.stopResize);
		ReactDOM.findDOMNode(this).removeEventListener('touchcancel', this.stopResize);
		window.removeEventListener('resize', this.updatePanelsSize);
	}

	startResize = (event, index) => {
		this.setState({
			isDragging: true,
			currentPanel: index,
			initialPos: event.clientX || event.touches[0].pageX
		});
	}

	stopResize = () => {
		if (this.state.isDragging) {
			let panels = [...this.state.panels];
			panels[this.state.currentPanel] = (this.state.panels[this.state.currentPanel] || 0) - this.state.delta;
			panels[this.state.currentPanel - 1] = (this.state.panels[this.state.currentPanel - 1] || 0) + this.state.delta;

			if (this.state.delta > 0 && this.props.children[this.state.currentPanel].props.minwidth) {
				let minWidth = this.props.children[this.state.currentPanel].props.minwidth;
				let newWidth = (this.state.panels[this.state.currentPanel] || 0) - this.state.delta;

				if (newWidth < minWidth) {
					let deltaWidth = this.state.delta - (minWidth - newWidth);
					panels[this.state.currentPanel] = minWidth;
					panels[this.state.currentPanel - 1] = (this.state.panels[this.state.currentPanel - 1] || 0) + deltaWidth;
				}
			} else if (this.state.delta < 0 && this.props.children[this.state.currentPanel - 1].props.minwidth){
				let minWidth = this.props.children[this.state.currentPanel - 1].props.minwidth;
				let newWidth = (this.state.panels[this.state.currentPanel - 1] || 0) + this.state.delta;

				if (newWidth < minWidth) {
					let deltaWidth = this.state.delta + (minWidth - newWidth);
					panels[this.state.currentPanel] = (this.state.panels[this.state.currentPanel] || 0) - deltaWidth;
					panels[this.state.currentPanel - 1] = minWidth;
				}
			}

			this.setState({
				isDragging: false,
				panels: panels,
				delta: 0,
				currentPanel: null
			});
			EventManager.emit(EVENTS.WINDOW_RESIZE);
		}
	}

	resizePanel = (event) => {
		if (this.state.isDragging) {
			const delta = (event.clientX || (event.touches && event.touches.length ? event.touches[0].pageX : 0)) - this.state.initialPos;
			this.setState({
				delta: delta
			});
		}
	}

	updatePanelsSize = (init) => {
		let panels;
		let windowWidth = window.innerWidth - (this.state.panels.length - 1) * 8; // remove resizers width

		// mobile size case
		if (window.innerWidth <= 1000) {
			windowWidth = window.innerWidth; // no resizers for mobile
			panels = this.state.panels.map((value, index) => index === 0 ? windowWidth : 0);
		} else if (this.state.oldWindowWidth <= 1000) {
			let rest = windowWidth;
			panels = this.state.panels.map((value, index) => {
				if (this.props.children[index].props.minwidth) {
					rest -= this.props.children[index].props.minwidth;
					return this.props.children[index].props.minwidth;
				}
				return 0;
			});
			if (rest > 0) {
				// split the extra space equally to keep the ratio of the panels
				let half = window.parseInt(rest / 2);
                panels[0] += half; 
                panels[1] += rest - half;
			}

		} else if (windowWidth > this.state.oldWindowWidth) { // add extra space equally
			panels = this.state.panels.map((crtPanel) => { return crtPanel * windowWidth / this.state.oldWindowWidth; });
		} else { // remove space equally taking into account the minimum width
			var rest = 0;
			panels = this.state.panels.map((crtPanel, index) => { 
				let newSize = crtPanel * windowWidth / this.state.oldWindowWidth; 
				if (this.props.children[index].props.minwidth && this.props.children[index].props.minwidth > newSize) {
					rest += this.props.children[index].props.minwidth - newSize;
					return this.props.children[index].props.minwidth;
				} else {
					return newSize;
				}
			});
			if (rest > 0) {
				panels = panels.map((crtPanel, index) => { 
					let minWidth = this.props.children[index].props.minwidth;
					if (rest > 0 && minWidth && crtPanel > minWidth) {
						rest = rest - (crtPanel - minWidth);
						return rest < 0 ? minWidth-rest : minWidth;
					} else {
						return crtPanel;
					}
				});
			}
		}

		if (init !== true) {
			this.setState({
				panels: panels,
				oldWindowWidth: windowWidth
			});
			EventManager.emit(EVENTS.WINDOW_RESIZE);
		} else {
			return panels;
		}
	}

	render() {
		// const rest = this.props.children.slice(1);
		// let totalSize = 0;
		// this.state.panels.forEach((value, i) => { if (i < this.state.panels.length - 1) totalSize += value; });
		return (
			<React.Fragment>
				<div className="panel-container" onMouseUp={() => this.stopResize()}>
					{/* <div className="panel" style={{width: `${this.state.panels[0]}px)`}}>
						{this.props.children[0]}
					</div> */}
					{[].concat(...this.props.children.map((child, i) => {
						if (this.state.panels[i] === 0) {
							return [];
						} else {
							return [
								(i !== 0 && 
									<div 
										key={"Resizer_" + child.key} 
										style={this.state.currentPanel === i ? {left: this.state.delta} : {}}
										onMouseDown={(e) => this.startResize(e, i)} 
										onTouchStart={(e) => { this.startResize(e, i);}}
										className="resizer"/>),
								<div key={"Panel_"+ child.key} className="panel" style={{width: this.state.panels[i]}}>
									{child}
								</div>
							];
						}
					}))}
				</div>
				{this.props.children.map((child, i) => {
					if (this.state.panels[i] === 0) 
						return (
							<div key={"Panel_"+ child.key} className="panel">
								{child}
							</div>
						);
					return null;
				})}
			</React.Fragment>
		);
	}

}



// WEBPACK FOOTER //
// ./src/components/ResizablePanels/index.js